import { APP_INITIALIZER, ErrorHandler, Injector, NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SoPoCoreModule } from './core/core.module';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { MessengerModule } from './messenger/messenger.module';
import { MaintenanceModule } from './maintenance/maintenance.module';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { SopoErrorHandler } from './error-handler.service';
import { SopoPopupModule } from './sopo-popup/sopo-popup.module';
import { SharedModule } from './shared/shared.module';
import { Router } from "@angular/router";
import * as SentryAngular from "@sentry/angular";
import { SopoToastModule } from './sopo-popup/components/sopo-toast/sopo-toast.module';
import { GameTabManager } from './shared/services/game-tab-manager/game-tab-manager.interface';
import { isElectron } from './shared/utils/platform.utils';
import { ElectronGameTabManager } from './shared/services/game-tab-manager/electron-game-tab-manager.service';
import { BrowserGameTabManager } from './shared/services/game-tab-manager/browser-game-tab-manager.service';
@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            scrollAssist: false,
        }),
        AppRoutingModule,
        SoPoCoreModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),
        MatDialogModule,
        MatButtonModule,
        DragDropModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        MessengerModule,
        MaintenanceModule,
        HammerModule,
        SopoPopupModule,
        SharedModule,
        SopoToastModule,
    ],
    providers: [
        {
            provide: RouteReuseStrategy,
            useClass: IonicRouteStrategy,
        },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
        StatusBar,
        { provide: ErrorHandler, useValue: SentryAngular.createErrorHandler(),},
        { provide: SentryAngular.TraceService, deps: [Router], },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [SentryAngular.TraceService],
            multi: true,
        },
        {
            provide: GameTabManager,
            useFactory: (injector: Injector) => {
                return isElectron()
                    ? injector.get(ElectronGameTabManager)
                    : injector.get(BrowserGameTabManager);
            },
            deps: [Injector],
        },
        // { provide: ErrorHandler, useClass: SopoErrorHandler}
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    ],
    exports: [SoPoCoreModule, MatDialogModule, MatButtonModule, DragDropModule],
    bootstrap: [AppComponent]
})
export class AppModule {}
